import { render, staticRenderFns } from "./recaptchaText.vue?vue&type=template&id=2e6c634f&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6c634f')) {
      api.createRecord('2e6c634f', component.options)
    } else {
      api.reload('2e6c634f', component.options)
    }
    module.hot.accept("./recaptchaText.vue?vue&type=template&id=2e6c634f&", function () {
      api.rerender('2e6c634f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/common/recaptchaText.vue"
export default component.exports